module.exports = __webpack_public_path__ + "static/media/transalteIcon.1c51dec1.png";